import { useCallback } from 'react';
import { setStoryEditorChat } from 'admin/actions/story/set-story-editor-chat';
import { useAdminDispatch, useAdminSelector } from 'admin/reducers';
import { selectStoryEditorChatDraft, selectStoryEditorChatOpen } from 'admin/reducers/story-editor/selectors';

/**
 * State and actions for the story editor chat interface.
 */
export const useStoryEditorChatState = () => {
	const dispatch = useAdminDispatch();
	const isOpen = useAdminSelector(selectStoryEditorChatOpen);
	const draft = useAdminSelector(selectStoryEditorChatDraft);
	// TODO: gate by organization/user entitlement once the AI chat rollout flag lands
	const isEnabled = true;
	const onOpenChange = useCallback(
		(nextOpen: boolean) => dispatch(setStoryEditorChat({ open: nextOpen })),
		[dispatch]
	);
	const openWithDraft = useCallback(
		(text: string) => dispatch(setStoryEditorChat({ open: true, draft: { id: `${Date.now()}`, text } })),
		[dispatch]
	);

	return {
		isOpen: isEnabled && isOpen,
		isEnabled,
		draft,
		onOpenChange,
		openWithDraft,
	};
};
